import { defineStore } from 'pinia';
import { useStorage, useWindowSize } from '@vueuse/core';
import type { RemovableRef } from '@vueuse/core';
import { getStorageKey, STORES } from '@NavigationModule';

const { height, width } = useWindowSize();

const PRODUCTION_TAG_STORAGE_KEY = 'topnav-production-tag-hidden';

interface State {
  isNavigating: boolean;
  isSideNavExpanded: RemovableRef<boolean>;
  productionTagHidden: RemovableRef<boolean>;
}

export default defineStore('ui', {
  state: (): State => ({
    isNavigating: false,
    isSideNavExpanded: useStorage(getStorageKey(STORES.UI, 'isSideNavExpanded'), width.value > 768),
    productionTagHidden: useStorage(PRODUCTION_TAG_STORAGE_KEY, false),
  }),

  getters: {
    appHeight: () => height.value,
    appWidth: () => width.value,
  },

  actions: {
    toggleSideNav() {
      this.isSideNavExpanded = !this.isSideNavExpanded;
    },
    hideProductionTag() {
      this.productionTagHidden = true;
    },
    showProductionTag() {
      this.productionTagHidden = false;
    },
  },
});
